import { SLOTS_APIS } from "@/api_framework/api_config";
import { IBookingShiftAppointmentResponse } from "@/api_framework/api_modals/Bookings";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";

import { setLoading } from "@/app_redux/reducers/loading_reducer";
import { setShiftAppoitnemt } from "@/app_redux/reducers/slices/auth/slots_slice";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback, useRef } from "react";
import { useConfiguration } from "../../useConfiguration";
import { useCurlLogger } from "../../useCurlLogger";

AxiosCurlirize(axios, () => {});

// Define filter interface
interface IShiftBookingFilters {
  clinic_id?: string;
  city_id?: string;
  service_id?: string;
  sub_service_id?: string;
  date?: string;
  from_date?: string;
  to_date?: string;
  timestamp?: string;
}

export const useShiftBookingListAPI = () => {
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const latestRequestIdRef = useRef(0);

  const execute = useCallback(async (filters: IShiftBookingFilters = {}) => {
    const requestId = ++latestRequestIdRef.current;
    dispatch(
      setLoading({
        key: "isShiftAppointmentInProgress",
        status: true,
      }),
    );

    try {
      const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);

      const res: AxiosResponse<IBookingShiftAppointmentResponse> = await axios.post(
        SLOTS_APIS?.SHIFT_APPOINTMENT?.baseURL ?? "",
        filters,
        {
          headers: {
            Authorization: `${accessToken}`,
            "Content-Type": "application/json",
          },
        },
      );

      if (requestId !== latestRequestIdRef.current) return;

      if (res.data.status === true && res.data) {
        dispatch(
          setShiftAppoitnemt({
            data: res.data.data,
          }),
        );
      } else {
        dispatch(
          setShiftAppoitnemt({
            data: [],
          }),
        );
      }
    } catch (error) {
      const e = error as AxiosError;
      if (e.config?.["curlCommand"]) {
        sendCurl(e.config["curlCommand"]);
      }
      if (requestId !== latestRequestIdRef.current) return;
      dispatch(
        setShiftAppoitnemt({
          data: [],
        }),
      );
    } finally {
      if (requestId === latestRequestIdRef.current) {
        dispatch(
          setLoading({
            key: "isShiftAppointmentInProgress",
            status: false,
          }),
        );
      }
    }
  }, [dispatch, configuration, sendCurl]);

  return execute;
};
